import { dataFolder } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolder = /*#__PURE__*/createIcon(dataFolder)
export default IconFolder
